export const columnsUser = [
    {
      Header: "USERNAME",
      accessor: "username",
    },
    {
      Header: "EMAIL",
      accessor: "email",
    },
    {
      Header: "PASSWORD (Encrypted)",
      accessor: "password",
    },
    {
      Header: "ACTIVE",
      accessor: "active",
    },
    {
      Header: "USER GROUP",
      accessor: "role_id",
    },
    {
      Header: "UPDATE",
      accessor: "update",
    },
    {
      Header: "DISABLE",
      accessor: "disable",
    },
    {
      Header: "DELETE",
      accessor: "delete",
    },
  ];
  